import { useEffect, useState } from "react";
import msdBg from "./../../assets/images/msd-bg.png";
import "./parallax.scss";

const MIN_WIDTH = 200;
const MAX_WIDTH = 350;
const MAX_SCROLL = 3000; // Increase for slower effect

const Parallax = () => {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Progress for scroll-based movement
  const progress = Math.min(scroll / MAX_SCROLL, 1);
  // Mirror progress for ping-pong effect
  const mirrored = progress <= 0.5 ? progress * 2 : (1 - progress) * 2;

  const width = MIN_WIDTH + (MAX_WIDTH - MIN_WIDTH) * mirrored;

  // Move from edge (0) to center (20% - 140px) and back
  const leftPos = `calc(${mirrored * 20}% - ${mirrored * 140}px)`;
  const rightPos = `calc(${mirrored * 20}% - ${mirrored * 140}px)`;

  // Diagonal tilt based on scroll progress (max 25deg)
  const tilt = 25 * mirrored;

  return (
    <div className="parallax-bg-container">
      <img
        src={msdBg}
        alt=""
        className="parallax-bg parallax-bg--left"
        style={{
          width: `${width}px`,
          left: leftPos,
          top: `30%`,
          transform: `rotate(-${tilt}deg)`,
          position: "absolute",
        }}
        draggable={false}
      />
      <img
        src={msdBg}
        alt=""
        className="parallax-bg parallax-bg--right"
        style={{
          width: `${width}px`,
          right: rightPos,
          top: `65%`,
          transform: `rotate(${tilt}deg)`,
          position: "absolute",
        }}
        draggable={false}
      />
    </div>
  );
};

export default Parallax;
